export enum ActionTypes {
  GetTestingCreditsPlans = 'getTestingCreditsPlans',
  GetTestingCreditsPlansSuccess = 'getTestingCreditsPlans.success',
  GetTestingCreditsPlansFailure = 'getTestingCreditsPlans.failure',
}
